import { confirm } from 'util/confirm'
import { fetchAttendeeList } from './ducks'
import updateAttendee from 'controllers/ticket/updateAttendee'
import __R, { userCan } from 'containers/__R';
import locale from './locale'

export default function () {

	const { dispatch } = this.props
	const { posterId, pagination, filterData, keyword, orderBy } = this.state
	const { itemsCountPerPage } = pagination;
	const schoolId = localStorage.getItem('schoolId')

	return [
		{
			title: __('Detail', 'registrationTable'),
			onClick: ({ trData: attendeeInfo }, event) => {
				this.setState({ openFloatModal: true, floatTarget: event.target, attendeeInfo: attendeeInfo }, () => {
					this.forceUpdate();
				});
			}
		},
		{
			title: __('Transfer Student', 'registrationTable'),
			onClick: ({ trData: attendeeInfo }) => {
				confirm(__('Proceed to transfer student?', locale))
					.then(() => {
						updateAttendee(attendeeInfo.attendee_id, { state: 'transferred' })
							.then((res) => {
								dispatch(fetchAttendeeList(schoolId, {
									posterId: posterId,
									state: filterData.registrationStatus ? filterData.registrationStatus.items[0].value : 6,
									amount_per_page: itemsCountPerPage,
									page_number: 1,
									order_by: orderBy,
									kw: keyword
								}))
							})
					})
					.catch(() => { })
			},
			isDisabled: ({ trData: attendeeInfo }) => {
				return attendeeInfo.state == 4 || !userCan('convert_attendee_to_student')
			}

		}
	]
}



// WEBPACK FOOTER //
// ./src/containers/pages/Poster/RegistrationTable/table-settings.js